import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, resolveUrl } from "@/lib/api";

export const ImageUpload = ({ value, onChange, aspect = "16 / 9", hint = "Click to upload image", className = "", testId }) => {
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  const pick = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/images", fd);
      onChange(data.url);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => ref.current?.click()}
        className="relative w-full rounded-lg border border-dashed border-[#D1D5DB] bg-[#F3F4F6] overflow-hidden hover:border-[#111] transition-colors"
        style={{ aspectRatio: aspect }}
        data-testid={testId}
      >
        {value && <img src={resolveUrl(value)} alt="" className="absolute inset-0 w-full h-full object-cover" />}
        {(!value || busy) && (
          <span className="absolute inset-0 flex items-center justify-center px-2 text-center text-[12px] text-[#6B7280] bg-white/60">
            {busy ? "Uploading…" : hint}
          </span>
        )}
      </button>
      {value && !busy && (
        <button type="button" onClick={() => onChange(null)} className="mt-1 text-[12px] text-[#6B7280] hover:text-[#B91C1C]" data-testid={testId ? `${testId}-remove` : undefined}>
          Remove image
        </button>
      )}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={(e) => pick(e.target.files?.[0])} />
    </div>
  );
};
